import { render } from "./MultiplePhotoSimpleComponent.vue?vue&type=template&id=d1e9bcd0&ts=true"
import script from "./MultiplePhotoSimpleComponent.vue?vue&type=script&lang=ts"
export * from "./MultiplePhotoSimpleComponent.vue?vue&type=script&lang=ts"

import "./MultiplePhotoSimpleComponent.vue?vue&type=style&index=0&id=d1e9bcd0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__